import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { IndexPageComponent } from './index-page/index-page.component'
import { SignInPageComponent } from './sign-in-page/sign-in-page.component'
import { SignUpPageComponent } from './sign-up-page/sign-up-page.component'
import { CoreModule } from '../core/core.module'
import { RouterModule } from '@angular/router'
import { ParkingPageComponent } from './parking-page/parking-page.component'
import { ParkingMapSearchPageComponent } from './parking-map-search-page/parking-map-search-page.component'
import { ForgotPasswordPageComponent } from './forgot-password-page/forgot-password-page.component'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { AuthenticationModule } from '../authentication/authentication.module'
import { ParkingSnippetComponent } from './parking-snippet/parking-snippet.component'
import { MerchantParkingModule } from '../../merchant/merchant-parking/merchant-parking.module'
import { ParkingModule } from '../parking/parking.module'
import { ClientChoosePaymentMethodComponent } from './client-choose-payment-method/client-choose-payment-method.component'
import { PaygateResultPageComponent } from './paygate/paygate-result-page/paygate-result-page.component'
import { PaygateRequestComponent } from './paygate/paygate-request/paygate-request.component'
import { ClientSubscriptionsModule } from '../../client/client-subscriptions/client-subscriptions.module'
import { CarouselModule } from 'ngx-bootstrap/carousel'
import { EttiquettePageComponent } from './ettiquette-page/ettiquette-page.component'
import { TermsAndConditionsPageComponent } from './terms-and-conditions-page/terms-and-conditions-page.component'
import { PrivacyPageComponent } from './privacy-page/privacy-page.component'
import { SafetyAndTrustPageComponent } from './safety-and-trust-page/safety-and-trust-page.component'
import { FaqsPageComponent } from './faqs-page/faqs-page.component'
import { AboutUsPageComponent } from './about-us-page/about-us-page.component'
import { ContactPageComponent } from './contact-page/contact-page.component'
import { AboutCollectorComponent } from './about-collector/about-collector.component'
import { DataDeletionComponent } from './data-deletion/data-deletion.component'
import { BlogListPageComponent } from './blog-list-page/blog-list-page.component'
import { BlogPageComponent } from './blog-page/blog-page.component'
import { NgSelectModule } from '@ng-select/ng-select'
import { BookingThankYouPageComponent } from './booking-thank-you-page/booking-thank-you-page.component'
import { CorporatePageComponent } from './corporate-page/corporate-page.component'
import { VerifyEmailPageComponent } from './verify-email-page/verify-email-page.component'
import { WhitelabelComponent } from './whitelabel/whitelabel.component'
import { BookuppInfoPageComponent } from './bookupp-info-page/bookupp-info-page.component'
import { ParkingPageBookuppComponent } from './parking-page-bookupp/parking-page-bookupp.component'
import { ParkingPageClassicComponent } from './parking-page-classic/parking-page-classic.component'
import { FaqsPageBookuppComponent } from './faqs-page-bookupp/faqs-page-bookupp.component'
import { ContactPageBookuppComponent } from './contact-page-bookupp/contact-page-bookupp.component'
import { BookuppFaqPageComponent } from './bookupp-faq-page/bookupp-faq-page.component'
import { ClientSubscriptionCardComponent } from '../subscriptions/client-subscription-card/client-subscription-card.component'
import { SubscriptionsModule } from '../subscriptions/subscriptions.module'
import { EnquiryFormComponent } from './enquiry-form/enquiry-form.component'
import { HowItWorksComponent } from './how-it-works/how-it-works.component'

@NgModule({
    declarations: [
        IndexPageComponent,
        SignInPageComponent,
        SignUpPageComponent,
        ParkingPageComponent,
        ParkingMapSearchPageComponent,
        ForgotPasswordPageComponent,
        ParkingSnippetComponent,
        ClientChoosePaymentMethodComponent,
        PaygateRequestComponent,
        PaygateResultPageComponent,
        EttiquettePageComponent,
        TermsAndConditionsPageComponent,
        PrivacyPageComponent,
        SafetyAndTrustPageComponent,
        ContactPageComponent,
        FaqsPageComponent,
        AboutUsPageComponent,
        DataDeletionComponent,
        AboutCollectorComponent,
        BlogListPageComponent,
        BlogPageComponent,
        BookingThankYouPageComponent,
        CorporatePageComponent,
        VerifyEmailPageComponent,
        WhitelabelComponent,
        BookuppInfoPageComponent,
        ParkingPageBookuppComponent,
        ParkingPageClassicComponent,
        FaqsPageBookuppComponent,
        ContactPageBookuppComponent,
        BookuppFaqPageComponent,
        ClientSubscriptionCardComponent,
        EnquiryFormComponent,
        HowItWorksComponent,
    ],
    imports: [
        CommonModule,
        CoreModule,
        RouterModule,
        AuthenticationModule,
        ReactiveFormsModule,
        FormsModule,
        MerchantParkingModule,
        ParkingModule,
        ClientSubscriptionsModule,
        CarouselModule,
        NgSelectModule,
        SubscriptionsModule,
    ],
    exports: [ClientChoosePaymentMethodComponent, ClientSubscriptionCardComponent],
})
export class SharedPagesModule {}
